import './SidebarToggle.scss';

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Sidebar toggle component
 * @module
 * @param {string} sidebarType - Sidebar type ('normal','compact','fullscreen')
 * @param {func} onClick - Function invoked on click
 * @param {object} [sideBarToggleIcons] - Sidebar toggle icons
 */
const SidebarToggle = (props) => {
  const base = "sidebar-toggle k-icon k-font-icon";
  const compactSidebarClassNames = `${base} compact ${props.sideBarToggleIcons && props.sideBarToggleIcons.compactIcon ? props.sideBarToggleIcons.compactIcon : "k-i-arrow-chevron-right"}`;
  const normalSidebarClassNames = `${base} ${props.sideBarToggleIcons && props.sideBarToggleIcons.normalIcon ? props.sideBarToggleIcons.normalIcon : "k-i-arrow-chevron-left"}`;
  const fullscreenSidebarClassNames = `${base} fullscreen ${props.sideBarToggleIcons && props.sideBarToggleIcons.fullscreen ? props.sideBarToggleIcons.fullscreen : "k-i-arrow-chevron-left"}`;

  const evaluateSidebarToggleClassNames = () => {
    switch (props.sidebarType) {
      case 'compact':
        return compactSidebarClassNames;
      case 'fullscreen':
        return fullscreenSidebarClassNames;
      default:
        return normalSidebarClassNames;
    }
  }

  return (
    <span className={`${props.sidebarType === "compact" ? "sidebar-toggle-compact-background" : ""}`}>
      <span
        onClick={props.onClick}
        className={evaluateSidebarToggleClassNames()}
      />
    </span>
  );
}

SidebarToggle.propTypes = {
  sidebarType: PropTypes.oneOf([
    'normal',
    'compact',
    'fullscreen',
  ]),
  onClick: PropTypes.func.isRequired,
  sideBarToggleIcons: PropTypes.object,
}

export default SidebarToggle;